import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2503199f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inpaint-edit" }
const _hoisted_2 = { class: "inpaint-edit__settings" }
const _hoisted_3 = { class: "inpaint-edit__settings__content" }
const _hoisted_4 = { class: "inpaint-edit__box" }
const _hoisted_5 = { class: "inpaint-edit__workarea__data" }
const _hoisted_6 = { class: "inpaint-edit__box" }
const _hoisted_7 = {
  key: 0,
  class: "inpaint-edit__controllers"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "inpaint-edit__controllers"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "inpaint-edit__workarea" }
const _hoisted_12 = { class: "inpaint-edit__canvas" }
const _hoisted_13 = { class: "inpaint-edit__canvas-box" }
const _hoisted_14 = { class: "inpaint-edit__canvas__zoom" }
const _hoisted_15 = { class: "inpaint-edit__workarea__data" }
const _hoisted_16 = { class: "inpaint-edit__workarea__actions" }

import { onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useEventBus } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { useServicesStore } from '@/store/services';
import { useCommonStore } from '@/store/common';

import { ICanvasImage } from '@/types/ICanvasImage';
import { TMode } from '@/types/TMode';

import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';
// import { getBase64Size } from '@/helpers/getBase64Size';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiCanvas from '@/components/UI/AiCanvas/AiCanvas.vue';
import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';
import AiSceleton from '@/components/UI/AiSceleton/AiSceleton.vue';
import AiTooltip from '@/components/UI/AiTooltip/AiTooltip.vue';

import AddImage from '@/components/common/AddImage/AddImage.vue';
import ImageFinetune from '@/components/common/ImageFinetune/ImageFinetune.vue';
import ResultImage from '@/components/common/ResultImage/ResultImage.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';

interface ICanvasData {
  activeProductId?: string;
  image: string;
  mask: string;
  products: ICanvasImage[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Inpaint',
  setup(__props) {

const { t } = useI18n();

const busError = useEventBus<string>('toast-error');

const { generateImage } = useServicesStore();

const { isMobile } = storeToRefs(useCommonStore());
const { imageForActions, imageResult, imagePrev } = storeToRefs(useServicesStore());

const key = ref<number>(0);
const loading = ref<boolean>(false);
const generationLoading = ref<boolean>(false);
const imageWidth = ref<number>(0);
const imageHeight = ref<number>(0);
const activeZoom = ref<number>(1);
const canvasWidth = ref<number>(600);
const canvasHeight = ref<number>(600);
const mode = ref<TMode>('erase');
const brushSize = ref<number>(110);
const aiCanvasRef = ref<any>(null);
const canvasData = ref<ICanvasData>({
  image: '',
  mask: '',
  products: [],
});

const isEdit = ref<boolean>(false);

// const imageSize = computed(() => getBase64Size(imageForActions.value));

const inpaintFileHandler = async (): Promise<void> => {
  generationLoading.value = true;
  if (aiCanvasRef.value) {
    aiCanvasRef.value.canvasUpdateData();
    const img = await aiCanvasRef.value.getBackground();
    generateImage({
      action: 'inpaint',
      image: removeBase64Prefix(imageForActions.value),
      params: {
        mask: removeBase64Prefix(img.enlargedBase64mask),
      },
    })
      .then((res) => {
        imagePrev.value = imageForActions.value;
        imageResult.value = `data:image/jpeg;base64,${res.image}`;
      })
      .catch((e) => {
        busError.emit(e?.message || t('common.err-gen'));
      })
      .finally(() => {
        generationLoading.value = false;
      });
  }
};

const zoomInHandler = (): void => {
  activeZoom.value += 0.1;
};

const zoomOutHandler = (): void => {
  activeZoom.value -= 0.1;
};

const activeZoomSetHandler = (newVal: number): void => {
  activeZoom.value = newVal;
};

const canvasUpdateHandler = (data: any): void => {
  if (!loading.value) {
    canvasData.value = data;
  }
};

const setMode = (modeVal: TMode): void => {
  mode.value = modeVal;
};

const imageSizeHandler = (): void => {
  if (imageForActions.value !== '') {
    const img = new Image();
    img.onload = () => {
      imageWidth.value = img.width;
      imageHeight.value = img.height;
      canvasWidth.value = img.width;
      canvasHeight.value = img.height;
    };
    img.src = imageForActions.value;
    key.value += 1;
  }
};

const editHandler = (image: string): void => {
  imageForActions.value = image;
  isEdit.value = false;
};

onMounted(() => {
  imageSizeHandler();
});

watch(imageForActions, () => {
  imageSizeHandler();
});

return (_ctx: any,_cache: any) => {
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_unref(imageForActions) === '' && _unref(imageResult) === '')
    ? (_openBlock(), _createBlock(AddImage, { key: 0 }))
    : (_unref(imageForActions) !== '' && _unref(imageResult) === '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["service__container inpaint", { 'service__container--mobile': _unref(isMobile) }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (isEdit.value)
              ? (_openBlock(), _createBlock(ImageFinetune, {
                  key: 0,
                  class: "inpaint-edit__finetune",
                  src: _unref(imageForActions),
                  onReset: _cache[0] || (_cache[0] = ($event: any) => (isEdit.value = false)),
                  onSave: editHandler,
                  actions: ['reset', 'save']
                }, null, 8, ["src"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.size')), 1),
                        _createVNode(_component_v_slider, {
                          min: 0,
                          max: 220,
                          modelValue: brushSize.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((brushSize).value = $event)),
                          modelModifiers: { number: true }
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.brush-type')), 1),
                          (!_unref(isMobile))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createVNode(AiTooltip, {
                                  "content-class": "inpaint-edit__tooltip",
                                  top: "",
                                  location: "top"
                                }, {
                                  top: _withCtx(() => [
                                    _createVNode(AiClearButton, {
                                      class: _normalizeClass([{ 'inpaint-edit__controller--active': mode.value === 'erase' }, "inpaint-edit__controller"]),
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (setMode('erase')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: require('@/assets/icons/editor/removeBg.svg'),
                                          alt: "#"
                                        }, null, 8, _hoisted_8)
                                      ]),
                                      _: 1
                                    }, 8, ["class"])
                                  ]),
                                  content: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('image-editor.erase')), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('image-editor.erase-tooltip-text')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(AiTooltip, {
                                  "content-class": "inpaint-edit__tooltip",
                                  top: "",
                                  location: "top"
                                }, {
                                  top: _withCtx(() => [
                                    _createVNode(AiClearButton, {
                                      class: _normalizeClass([{ 'inpaint-edit__controller--active': mode.value === 'restore' }, "inpaint-edit__controller"]),
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (setMode('restore')))
                                    }, null, 8, ["class"])
                                  ]),
                                  content: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('image-editor.restore-brush')), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('image-editor.restore-tooltip-text')), 1)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(isMobile))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(AiClearButton, {
                                  class: _normalizeClass([{ 'inpaint-edit__controller--active': mode.value === 'erase' }, "inpaint-edit__controller"]),
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (setMode('erase')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: require('@/assets/icons/editor/removeBg.svg'),
                                      alt: "#"
                                    }, null, 8, _hoisted_10)
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(AiClearButton, {
                                  class: _normalizeClass([{ 'inpaint-edit__controller--active': mode.value === 'restore' }, "inpaint-edit__controller"]),
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (setMode('restore')))
                                }, null, 8, ["class"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_v_spacer)
                      ]),
                      (_unref(isMobile))
                        ? (_openBlock(), _createBlock(AiButton, {
                            key: 0,
                            theme: "gradient-primary",
                            disabled: generationLoading.value,
                            onClick: inpaintFileHandler,
                            class: "inpaint-edit__settings__button",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (!generationLoading.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('inpaint.inpaint')), 1)
                                  ], 64))
                                : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(AiCard, {
                      radius: 16,
                      class: "inpaint-edit__workarea__card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            (loading.value)
                              ? (_openBlock(), _createBlock(AiSceleton, {
                                  key: 0,
                                  class: "inpaint-edit__canvas__sceleton"
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(AiClearButton, {
                                class: "inpaint-edit__canvas__zoom__button",
                                "active-zoom": activeZoom.value,
                                onClick: zoomOutHandler
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_inline_svg, {
                                    src: require('@/assets/icons/IconDecrease.svg')
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              }, 8, ["active-zoom"]),
                              _createVNode(AiClearButton, {
                                class: "inpaint-edit__canvas__zoom__button",
                                onClick: zoomInHandler
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_inline_svg, {
                                    src: require('@/assets/icons/IconIncrease.svg')
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              })
                            ]),
                            (_openBlock(), _createBlock(AiCanvas, {
                              resetExistingImageTransformsOnChangeImages: false,
                              images: [],
                              width: canvasWidth.value,
                              height: canvasHeight.value,
                              onCanvasUpdate: canvasUpdateHandler,
                              background: _unref(imageForActions),
                              mode: mode.value,
                              key: key.value,
                              ref_key: "aiCanvasRef",
                              ref: aiCanvasRef,
                              "brush-size": brushSize.value,
                              "active-zoom": activeZoom.value,
                              onActiveZoomSet: activeZoomSetHandler,
                              "bg-cover": ""
                            }, null, 8, ["width", "height", "background", "mode", "brush-size", "active-zoom"])),
                            (generationLoading.value)
                              ? (_openBlock(), _createBlock(AiDropLoader, { key: 1 }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_v_spacer),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(AiButton, {
                              theme: "dark",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (isEdit.value = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.correction')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(AiButton, {
                              theme: "dark",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => {
                    imagePrev.value = '';
                    imageForActions.value = '';
                    imageResult.value = '';
                  })
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
                              ]),
                              _: 1
                            }),
                            (!_unref(isMobile))
                              ? (_openBlock(), _createBlock(AiButton, {
                                  key: 0,
                                  disabled: generationLoading.value,
                                  theme: "gradient-primary",
                                  class: "inpaint-edit__workarea__button",
                                  onClick: inpaintFileHandler
                                }, {
                                  default: _withCtx(() => [
                                    (!generationLoading.value)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('inpaint.inpaint')), 1)
                                        ], 64))
                                      : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
          ])
        ], 2))
      : (_unref(imageForActions) !== '' && _unref(imageResult) !== '')
        ? (_openBlock(), _createBlock(ResultImage, { key: 2 }))
        : _createCommentVNode("", true)
}
}

})